// Temporary flag to hide anomaly phrases until the backend bugs are fixed. When this feature is ready we should delete
// this constant altogether rather than just setting to true because it hurts code coverage.
export const ANOMALY_PHRASES_ENABLED = false;
